export default function ConsumeBean() {
    this.chargeId = ''
    this.chargeName = ''
    this.chargeTime = ''
    this.chargeAmount = ''
    this.chargeStatus = -1
}